import { takeLatest, all, call, fork, put } from "redux-saga/effects";
import { workspaceManager } from "../../constants/actionTypes";
import {
  setGetWorkspaceListLoading,
  setWorkspaceManagerList,
  setWorkspaceManagerListError,
  workSpaceCreateSuccess,
  workSpaceCreateError,
  saveWorkspaceLoading,
  worksSpaceAddResourceSuccess,
  worksSpaceAddResourceError,
  createAuthConfigSuccess,
  createAuthConfigError,
  setResourceTemplate,
  setDeleteWorkspaceSuccess,
  setWorkspaceLoading,
  setInstanceSizeAndPricingProfile,
  setWorkspaceResource,
  errorWorkspaceDetails,
  errorWorkspaceDetailsUsers,
  setWorkspaceDetails,
  successWorkspaceDetailsUsers,
  instanceSizeAndPricingProfileLoading,
  setActiveWorkspace,
  setAuthLoading,
  setResourceLoading,
  setWorkspaceAuthConfig,
  setResTemplateLoading,
  setPostApiSuccessful,
  setWorkspaceActionSuccess,
  setWorkspaceResourceList,
  setWorkspaceResourceListError,
  setPublicWorkspaceResourceList,
  setPublicWorkspaceResourceListError,
  setPublicWorkspaceListLoading,
  setUserInvitation,
  setUserInvitationLoading,
  setLinkDelinkLoading,
  setLinkDeLinkSuccess,
  successDeleteWorkspaceUser,
  errorDeleteWorkspaceUser,
  successDownloadInvitation,
  errorDownloadInvitation,
  generateInviteLoading,
  setInviteLink,
  workSpaceEditSuccess,
  successResendInvitation,
  errorResendInvitation,
  successTenantListForUsage,
  errorTenantListForUsage,
  successWorkspaces,
  errorWorkspaces,
  successGenerateReport,
  errorGenerateReport,
  successGenerateReportList,
  errorGenerateReportList,
  setWorkspaceAuthConfigError,
  setWorkspaceVerified,
  setWorkspaceVerifiedError,
  setInviteLinkAvailable,
  setInviteSuccess,
  setInviteError,
  extensionValidityGetSuccess,
  extensionValidityGetError,
  myLabsLoaderSuccess,
  LoginForAADSuccess,
  LoginForAADError,
  workSpaceAuthSuccess,
  workSpaceAuthError,
  setTenantListForWorkspace,
  successWorkspaceAddUser,
  errorWorkspaceAddUser,
  successWorkspaceEditUser,
  errorWorkspaceEditUser,
  addWorkspaceResourcesLoading,
  addWorkspaceResourcesSuccess,
  addWorkspaceResourcesError,
  getAllCloudVMSkuError,
  getAllCloudVMSkuLoading,
  getAllCloudVMSkuSuccess,
  getAllCloudVMInstanceSuccess,
  getAllCloudVMInstanceError,
  getAllCloudVMInstanceLoading,
} from "../../store/actions";
import { statusCode } from "../../constants/apis/apiStatus";
import {
  fetchWorkspaceList,
  createWorkspaceRequest,
  editWorkSpaceRequest,
  createResourceRequest,
  editResourceRequest,
  addAuthRequest,
  editAuthRequest,
  getResourceTemplatesRequest,
  retrieveWorkspace,
  deleteWorkspaceDashboard,
  getWorkSpaceById,
  getInstanceAndPricing,
  getResourceByIdRequest,
  getAuthConfigByIdRequest,
  workspaceActionHandler,
  fetchWorkspaceResourceList,
  fetchPublicWorkspaceResourceList,
  linkDelinkRequest,
  listUserInvitationRequest,
  getWorkspaceDetailsUsers,
  deleteWorkspaceUserInvitation,
  downloadInvitationCsv,
  generateInviteUrlRequest,
  resendInvitationApi,
  getWorkspaceTenantList,
  getWorkspaces,
  getPreviousUsageReports,
  generateReport,
  getInvitationApi,
  getExtendWorkspacePacksRequest,
  fetchTenantListForWorkspace,
  workspaceAddUserApi,
  workspaceEditUserApi,
  addWorkspaceResourceApi,
  getAllSkuCloudVMApi,
  getAllInstanceCloudVMApi,
} from "../api/workspaceManager";
import {
  toasterFlags,
  errorWentWrong,
} from "../../constants/componentConstants";
import { toastNotification } from "../../utils/toast";
import { getAuthTokenDetails } from "../api/api";

function* getWorkspaceDashboardList({ data }) {
  yield put(setGetWorkspaceListLoading(true));
  try {
    const workspaceListData = yield call(fetchWorkspaceList, data);
    if (workspaceListData?.status === statusCode.Ok200) {
      yield put(setWorkspaceManagerList(workspaceListData));
    } else {
      toastNotification(toasterFlags.WARN, workspaceListData?.data?.message);
      yield put(setWorkspaceManagerListError(workspaceListData));
    }
  } catch (err) {
    yield put(setWorkspaceManagerListError(err));
    toastNotification(toasterFlags.WARN, errorWentWrong);
  }
  yield put(setGetWorkspaceListLoading(false));
}

function* createWorkspaceSaga({ payload }) {
  yield put(saveWorkspaceLoading(true));
  try {
    const workspaceData = yield call(createWorkspaceRequest, payload);
    if (workspaceData?.status === statusCode.Created201) {
      yield put(workSpaceCreateSuccess(workspaceData?.data));
    } else {
      toastNotification(toasterFlags.WARN, workspaceData?.data?.message);
      yield put(
        workSpaceCreateError(
          (workspaceData?.data &&
            workspaceData?.data?.error &&
            workspaceData?.data?.message) ||
          {}
        )
      );
    }
  } catch (err) {
    yield put(workSpaceCreateError({}));
    toastNotification(toasterFlags.WARN, errorWentWrong);
  }
  yield put(saveWorkspaceLoading(false));
}

function* editWorkspaceSaga({ payload }) {
  yield put(saveWorkspaceLoading(true));
  try {
    const workspaceData = yield call(editWorkSpaceRequest, payload);
    if (workspaceData?.status === statusCode.Ok200) {
      yield put(workSpaceEditSuccess(workspaceData?.data));
    } else {
      toastNotification(toasterFlags.WARN, workspaceData?.data?.message);
      yield put(
        workSpaceCreateError(
          (workspaceData?.data &&
            workspaceData?.data?.error &&
            workspaceData?.data?.message) ||
          {}
        )
      );
    }
  } catch (err) {
    yield put(workSpaceCreateError({}));
    toastNotification(toasterFlags.WARN, errorWentWrong);
  }
  yield put(saveWorkspaceLoading(false));
}

function* addResourceSaga({ payload }) {
  yield put(saveWorkspaceLoading(true));
  try {
    const workspaceData = yield call(createResourceRequest, payload);
    if (workspaceData?.status === statusCode.Created201) {
      yield put(worksSpaceAddResourceSuccess(workspaceData?.data));
      yield put(setPostApiSuccessful(true));
    } else {
      toastNotification(toasterFlags.WARN, workspaceData?.data?.message);
      yield put(
        worksSpaceAddResourceError(
          workspaceData?.data &&
          workspaceData?.data?.error &&
          workspaceData?.data?.message
        ) || {}
      );
    }
  } catch (err) {
    yield put(worksSpaceAddResourceError({}));
    toastNotification(toasterFlags.WARN, errorWentWrong);
  }
  yield put(saveWorkspaceLoading(false));
}

function* editResourceSaga({ payload }) {
  yield put(saveWorkspaceLoading(true));
  try {
    const workspaceData = yield call(editResourceRequest, payload);
    if (workspaceData?.status === statusCode.Ok200) {
      yield put(
        worksSpaceAddResourceSuccess({
          ...payload?.payload,
          ...workspaceData?.data,
        })
      );
      yield put(setPostApiSuccessful(true));
    } else {
      toastNotification(toasterFlags.WARN, workspaceData?.data?.message);
      yield put(
        worksSpaceAddResourceError(
          workspaceData?.data &&
          workspaceData?.data?.error &&
          workspaceData?.data?.message
        ) || {}
      );
    }
  } catch (err) {
    yield put(worksSpaceAddResourceError({}));
    toastNotification(toasterFlags.WARN, errorWentWrong);
  }
  yield put(saveWorkspaceLoading(false));
}
function* addAuthConfigSaga({ payload }) {
  yield put(saveWorkspaceLoading(true));
  try {
    const workspaceData = yield call(addAuthRequest, payload);
    if (workspaceData?.status === statusCode.Created201) {
      yield put(createAuthConfigSuccess(workspaceData));
      yield put(setPostApiSuccessful(true));
    } else {
      toastNotification(toasterFlags.WARN, workspaceData?.data?.message);
      yield put(
        createAuthConfigError(
          workspaceData?.data &&
          workspaceData?.data?.error &&
          workspaceData?.data?.message
        ) || {}
      );
    }
    yield put(saveWorkspaceLoading(true));
  } catch (err) {
    yield put(createAuthConfigError(err));
    toastNotification(toasterFlags.WARN, errorWentWrong);
  }
  yield put(saveWorkspaceLoading(false));
}
function* editAuthConfigSaga({ payload }) {
  yield put(saveWorkspaceLoading(true));
  try {
    const workspaceData = yield call(editAuthRequest, payload);
    if (workspaceData?.status === statusCode.Ok200) {
      yield put(createAuthConfigSuccess(workspaceData));
      yield put(setPostApiSuccessful(true));
    } else {
      toastNotification(toasterFlags.WARN, workspaceData?.data?.message);
      yield put(
        createAuthConfigError(
          workspaceData?.data &&
          workspaceData?.data?.error &&
          workspaceData?.data?.message
        ) || {}
      );
    }
    yield put(saveWorkspaceLoading(false));
  } catch (err) {
    yield put(createAuthConfigError({}));
    toastNotification(toasterFlags.WARN, errorWentWrong);
  }
  yield put(saveWorkspaceLoading(false));
}

function* getResourceTemplateSaga({ payload }) {
  yield put(setResTemplateLoading(true));
  try {
    const workspaceData = yield call(getResourceTemplatesRequest, payload);
    yield put(setResTemplateLoading(false));
    if (workspaceData?.status === statusCode.Ok200) {
      yield put(setResourceTemplate(workspaceData?.data));
    } else {
      toastNotification(toasterFlags.WARN, workspaceData?.data?.message);
      yield put(setResourceTemplate([]));
    }
  } catch (err) {
    yield put(setResTemplateLoading(false));
    yield put(setResourceTemplate([]));
    toastNotification(toasterFlags.WARN, errorWentWrong);
  }
}
function* getWorkspaceDetailsSagaFunction({ data }) {
  try {
    const workspaceDetailsData = yield call(retrieveWorkspace, data);
    if (workspaceDetailsData?.status === statusCode.Ok200) {
      yield put(setWorkspaceDetails(workspaceDetailsData?.data));
    } else {
      toastNotification(toasterFlags.WARN, workspaceDetailsData?.data?.message);
      yield put(errorWorkspaceDetails(workspaceDetailsData?.data));
    }
  } catch (error) {
    yield put(errorWorkspaceDetails(error));
  }
}

export function* getWorkspaceDetailsUsersSagaFunction({ id, urlParams }) {
  try {
    const workspaceDetailsUsersData = yield call(
      getWorkspaceDetailsUsers,
      id,
      urlParams
    );
    if (workspaceDetailsUsersData?.status === statusCode.Ok200) {
      yield put(successWorkspaceDetailsUsers(workspaceDetailsUsersData?.data));
    } else {
      toastNotification(
        toasterFlags.WARN,
        workspaceDetailsUsersData?.data?.message
      );
      yield put(errorWorkspaceDetailsUsers(workspaceDetailsUsersData?.data));
    }
  } catch (error) {
    yield put(errorWorkspaceDetailsUsers(error));
  }
}

export function* deleteWorkspaceUserInvitationSagaFunction({ data }) {
  try {
    const workspace = yield call(deleteWorkspaceUserInvitation, data);
    if (workspace?.status === statusCode.Ok200) {
      yield put(successDeleteWorkspaceUser(workspace?.data));
      toastNotification(toasterFlags.SUCCESS, workspace?.data?.success);
    } else {
      toastNotification(toasterFlags.WARN, workspace?.data?.message);
      yield put(errorDeleteWorkspaceUser(workspace?.data));
    }
  } catch (error) {
    yield put(errorDeleteWorkspaceUser(error));
  }
}

export function* downloadInvitationSaga({ data }) {
  try {
    const workspace = yield call(downloadInvitationCsv, data);
    if (workspace?.status === statusCode.Ok200) {
      yield put(successDownloadInvitation(workspace?.data));
    } else {
      toastNotification(toasterFlags.WARN, workspace?.data?.message);
      yield put(errorDownloadInvitation(workspace?.data));
    }
  } catch (error) {
    yield put(errorDownloadInvitation(error));
  }
}

export function* resendInvitationSaga({ data }) {
  try {
    const workspace = yield call(resendInvitationApi, data);
    if (workspace?.status === statusCode.Created201) {
      toastNotification(toasterFlags.SUCCESS, workspace?.data?.success);
      yield put(successResendInvitation(workspace?.data));
    } else {
      toastNotification(toasterFlags.WARN, workspace?.data?.message);
      yield put(errorResendInvitation(workspace?.data));
    }
  } catch (error) {
    yield put(errorResendInvitation(error));
  }
}

export function* deleteWorkspaceFunction({ payload }) {
  yield put(setGetWorkspaceListLoading(true));
  try {
    const workspaceDeleteData = yield call(deleteWorkspaceDashboard, payload);
    if (workspaceDeleteData?.status === statusCode.Ok200) {
      yield put(setDeleteWorkspaceSuccess(workspaceDeleteData));
    } else {
      toastNotification(toasterFlags.WARN, workspaceDeleteData?.data?.message);
      yield put(setGetWorkspaceListLoading(false));
    }
  } catch (err) {
    toastNotification(toasterFlags.WARN, errorWentWrong);
    yield put(setGetWorkspaceListLoading(false));
  }
}
export function* getWorkSpaceByIdSaga({ payload }) {
  yield put(setWorkspaceLoading(true));
  try {
    const workspace = yield call(getWorkSpaceById, payload);
    if (workspace?.status === statusCode.Ok200) {
      yield put(setActiveWorkspace(workspace?.data));
    } else {
      toastNotification(toasterFlags.WARN, workspace?.data?.message);
    }
    yield put(setWorkspaceLoading(false));
  } catch (err) {
    toastNotification(toasterFlags.WARN, errorWentWrong);
    yield put(setWorkspaceLoading(false));
  }
}

export function* getInstanceSizeAndPricingSaga({ payload }) {
  yield put(instanceSizeAndPricingProfileLoading(true));
  try {
    const workspace = yield call(getInstanceAndPricing, payload);
    if (workspace?.status === statusCode.Ok200) {
      yield put(setInstanceSizeAndPricingProfile(workspace?.data));
    } else {
      toastNotification(toasterFlags.WARN, workspace?.data?.message);
    }
    yield put(instanceSizeAndPricingProfileLoading(false));
  } catch (err) {
    toastNotification(toasterFlags.WARN, errorWentWrong);
    yield put(instanceSizeAndPricingProfileLoading(false));
  }
}
export function* getWorkspaceResourceByIdSaga({ payload }) {
  yield put(setInviteLinkAvailable("NOT_LOADED"));
  yield put(setResourceLoading(true));
  try {
    const workspace = yield call(getResourceByIdRequest, payload);
    if (workspace?.status === statusCode.Ok200) {
      yield put(setWorkspaceResource(workspace?.data));
    } else {
      toastNotification(toasterFlags.WARN, workspace?.data?.message);
    }
    yield put(setResourceLoading(false));
  } catch (err) {
    toastNotification(toasterFlags.WARN, errorWentWrong);
    yield put(setResourceLoading(false));
  }
}
export function* getWorkspaceAuthConfigbyIdSaga({ payload }) {
  yield put(setAuthLoading(true));
  try {
    const workspace = yield call(getAuthConfigByIdRequest, payload);
    if (workspace?.status === statusCode.Ok200) {
      yield put(
        setInviteLinkAvailable(
          !!workspace?.data?.invitation_link ? "AVAILABLE" : "NOT_AVAILABLE"
        )
      );
      yield put(setWorkspaceAuthConfig(workspace?.data));
      yield put(setWorkspaceAuthConfigError(false));
    } else {
      yield put(setInviteLinkAvailable("NOT_AVAILABLE"));
      yield put(setWorkspaceAuthConfigError(true));
      toastNotification(toasterFlags.WARN, workspace?.data?.message);
    }
    yield put(setAuthLoading(false));
  } catch (err) {
    yield put(setInviteLinkAvailable("NOT_AVAILABLE"));
    yield put(setWorkspaceAuthConfigError(true));
    toastNotification(toasterFlags.WARN, errorWentWrong);
    yield put(setAuthLoading(false));
  }
}
export function* workspaceActionHandlerFunction({ payload }) {
  yield put(setGetWorkspaceListLoading(true));
  try {
    const workspaceActionData = yield call(workspaceActionHandler, payload);
    if (workspaceActionData?.status === statusCode.Ok200) {
      yield put(setWorkspaceActionSuccess(workspaceActionData));
    } else {
      toastNotification(toasterFlags.WARN, workspaceActionData?.data?.message);
      yield put(setGetWorkspaceListLoading(false));
    }
  } catch (err) {
    toastNotification(toasterFlags.WARN, errorWentWrong);
    yield put(setGetWorkspaceListLoading(false));
  }
}

function* getWorkspaceResourceListFunction({ data }) {
  yield put(setGetWorkspaceListLoading(true));
  try {
    const resourceListData = yield call(fetchWorkspaceResourceList, data);
    if (resourceListData?.status === statusCode.Ok200) {
      yield put(setWorkspaceResourceList(resourceListData));
    } else {
      toastNotification(toasterFlags.WARN, resourceListData?.data?.message);
      yield put(setWorkspaceResourceListError(resourceListData));
    }
  } catch (err) {
    yield put(setWorkspaceManagerListError(err));
    toastNotification(toasterFlags.WARN, errorWentWrong);
  }
  yield put(setGetWorkspaceListLoading(false));
}

function* getPublicWorkspaceResourceListFunction({ data }) {
  yield put(setPublicWorkspaceListLoading(true));
  try {
    let resourceListData = yield call(fetchPublicWorkspaceResourceList, data);
    if (resourceListData?.status === statusCode.Ok200 || resourceListData?.status === 201) {
      const mappedResults = resourceListData.data?.results?.map((item) => ({
        ...item,
        vm_name: item.lab_name,
        username: item.user_name,
        duration_minutes: item.available_duration,
        vm_state: item.lab_status,
        ws_vm_status: item.status,
      }));
      resourceListData = {
        ...resourceListData,
        data: {
          ...resourceListData.data,
          results: mappedResults,
        },
      };
      yield put(setPublicWorkspaceResourceList(resourceListData));
    } else {
      toastNotification(toasterFlags.WARN, resourceListData?.data?.message);
      yield put(setPublicWorkspaceResourceListError(resourceListData));
    }
  } catch (err) {
    toastNotification(toasterFlags.WARN, errorWentWrong);
  }
  yield put(setPublicWorkspaceListLoading(false));
}
function* linkDeLinkResourceSaga({ payload }) {
  yield put(setLinkDelinkLoading(true));
  try {
    const resourceListData = yield call(linkDelinkRequest, payload);
    if (resourceListData?.status === statusCode.Ok200) {
      yield put(setLinkDeLinkSuccess(true));
    } else {
      yield put(setLinkDeLinkSuccess(false));
      toastNotification(toasterFlags.WARN, resourceListData?.data?.message);
    }
    yield put(setLinkDelinkLoading(false));
  } catch (err) {
    yield put(setLinkDelinkLoading(false));
    yield put(setLinkDeLinkSuccess(false));
    toastNotification(toasterFlags.WARN, errorWentWrong);
  }
  yield put(setLinkDelinkLoading(false));
}

function* listUserInivitationSaga({ payload }) {
  yield put(setUserInvitationLoading(true));
  try {
    const users = yield call(listUserInvitationRequest, payload);
    if (users?.status === statusCode.Ok200) {
      yield put(setUserInvitation(users?.data?.results));
    } else {
      toastNotification(toasterFlags.WARN, users?.data?.message);
      yield put(setUserInvitation([]));
    }
    yield put(setUserInvitationLoading(false));
  } catch (err) {
    yield put(setUserInvitation([]));
    toastNotification(toasterFlags.WARN, errorWentWrong);
  }
  yield put(setUserInvitationLoading(false));
}

function* generateInviteLinkSaga({ payload }) {
  yield put(generateInviteLoading(true));
  try {
    const users = yield call(generateInviteUrlRequest, payload);
    if (users?.status === statusCode.Ok200) {
      yield put(setInviteLink(users?.data));
    } else {
      toastNotification(toasterFlags.WARN, users?.data?.message);
      yield put(setInviteLink(null));
    }
    yield put(generateInviteLoading(false));
  } catch (err) {
    yield put(setInviteLink(null));
    toastNotification(toasterFlags.WARN, errorWentWrong);
  }
  yield put(generateInviteLoading(false));
}

export function* getWorkspaceTenantsSaga({ data }) {
  try {
    const workspace = yield call(getWorkspaceTenantList, data);
    if (workspace?.status === statusCode.Ok200) {
      yield put(successTenantListForUsage(workspace?.data));
    } else {
      toastNotification(toasterFlags.WARN, workspace?.data?.message);
      yield put(errorTenantListForUsage(workspace?.data));
    }
  } catch (error) {
    yield put(errorTenantListForUsage(error));
  }
}

export function* getWorkspacesSaga({ data, params = {} }) {
  try {
    const workspace = yield call(getWorkspaces, data, params);
    if (workspace?.status === statusCode.Ok200) {
      yield put(successWorkspaces(workspace?.data));
    } else {
      toastNotification(toasterFlags.WARN, workspace?.data?.message);
      yield put(errorWorkspaces(workspace?.data));
    }
  } catch (error) {
    yield put(errorWorkspaces(error));
  }
}

export function* getPreviousUsageReportSaga({ data }) {
  try {
    const workspace = yield call(getPreviousUsageReports, data);
    if (workspace?.status === statusCode.Ok200) {
      yield put(successGenerateReportList(workspace?.data));
    } else {
      toastNotification(toasterFlags.WARN, workspace?.data?.message);
      yield put(errorGenerateReportList(workspace?.data));
    }
  } catch (error) {
    yield put(errorGenerateReportList(error));
  }
}
export function* generateReportSaga({ data }) {
  try {
    const workspace = yield call(generateReport, data);
    if (
      workspace?.status === statusCode.Created201 ||
      workspace?.status === statusCode.Ok200
    ) {
      toastNotification(toasterFlags.SUCCESS, workspace?.data?.success);
      yield put(successGenerateReport(workspace?.data));
    } else {
      toastNotification(toasterFlags.WARN, workspace?.data?.message);
      yield put(errorGenerateReport(workspace?.data));
    }
  } catch (error) {
    yield put(errorGenerateReport(error));
  }
}

export function* getInvitation({ data }) {
  try {
    const workspace = yield call(getInvitationApi, data);
    if (workspace?.status === statusCode.Ok200) {
      yield put(
        setInviteSuccess({
          status: workspace?.status,
          data: workspace?.data?.success,
        })
      );
    } else {
      // toastNotification(toasterFlags.WARN, workspace.response.data.message);
      yield put(
        setInviteError({
          status: workspace?.response?.status,
          data: workspace?.response?.data,
        })
      );
    }
  } catch (error) {
    yield put(setInviteError(error));
  }
}

export function* getWorkSpaceVerified({ data }) {
  try {
    const workspace = yield call(getInvitationApi, data);
    if (workspace?.status === statusCode.Ok200) {
      yield put(
        setWorkspaceVerified({
          status: workspace?.status,
          data: workspace?.data?.success,
        })
      );
    } else {
      toastNotification(toasterFlags.WARN, workspace?.response?.data?.message);
      yield put(
        setWorkspaceVerifiedError({
          status: workspace?.response?.status,
          data: workspace?.response?.data,
        })
      );
    }
  } catch (error) {
    yield put(setInviteError(error));
  }
}

export function* getExtensionPackSaga({ data }) {
  try {
    const extVdtydata = yield call(getExtendWorkspacePacksRequest, data);
    if (extVdtydata?.status === statusCode.Ok200) {
      yield put(
        extensionValidityGetSuccess({
          data: extVdtydata?.data?.map?.((item) => ({
            ...item,
            validity_days: item?.extension_days,
            name: item?.extension_name,
            duration_minutes: item?.extension_min,
          })),
        })
      );
    } else {
      yield put(extensionValidityGetError(extVdtydata?.data?.message));
      yield put(myLabsLoaderSuccess(false));
    }
  } catch (err) {
    yield put(extensionValidityGetError(err));
    yield put(myLabsLoaderSuccess(false));
  }
}

export function* loginFunctionForAAD({ data }) {
  try {
    const LoginDataAAD = yield call(getInvitationApi, data);
    if (LoginDataAAD?.status === statusCode.Ok200) {
      yield put(
        LoginForAADSuccess({
          data: LoginDataAAD?.data?.success,
          status: LoginDataAAD?.status,
        })
      );
    } else {
      toastNotification(
        toasterFlags.ERROR,
        LoginDataAAD?.response?.data?.message
      );
      yield put(
        LoginForAADError({
          data: LoginDataAAD?.data,
          status: LoginDataAAD?.status,
        })
      );
    }
  } catch (err) {
    yield put(LoginForAADError(err));
  }
}

export function* getAuthResponseWs({ data }) {
  try {
    const workspaceAuthData = yield call(getAuthTokenDetails, data);
    if (workspaceAuthData?.status === statusCode.Ok200) {
      yield put(
        workSpaceAuthSuccess({
          data: workspaceAuthData?.data?.success,
          status: workspaceAuthData?.status,
        })
      );
    } else {
      toastNotification(
        toasterFlags.ERROR,
        workspaceAuthData?.response?.data?.message
      );
      yield put(
        workSpaceAuthError({
          data: workspaceAuthData?.response?.data,
          status: workspaceAuthData?.response?.status,
        })
      );
    }
  } catch (err) {
    yield put(LoginForAADError(err));
  }
}

export function* getTenantListFunction({ data }) {
  try {
    const tenantListData = yield call(fetchTenantListForWorkspace, data);
    if (tenantListData?.status === statusCode.Ok200) {
      yield put(
        setTenantListForWorkspace({
          data: tenantListData?.data?.results,
          status: tenantListData?.status,
        })
      );
    } else {
      yield put(
        setTenantListForWorkspace({ data: [], status: tenantListData?.status })
      );
    }
  } catch (err) {
    yield put(LoginForAADError(err));
  }
}

export function* workspaceAddUserFunction({ payload }) {
  try {
    const workspace = yield call(workspaceAddUserApi, payload);
    if (workspace?.status === statusCode.Created201) {
      yield put(successWorkspaceAddUser(workspace?.data));
    } else {
      toastNotification(toasterFlags.WARN, workspace?.data?.message);
      yield put(errorWorkspaceAddUser(workspace?.data));
    }
  } catch (error) {
    yield put(errorWorkspaceAddUser(error));
  }
}

export function* workspaceEditUserFunction({ payload, id }) {
  try {
    const workspace = yield call(workspaceEditUserApi, id, payload);
    if (workspace?.status === statusCode.Created201) {
      toastNotification(toasterFlags.SUCCESS, workspace?.data?.success);
      yield put(successWorkspaceEditUser(workspace?.data));
    } else {
      toastNotification(toasterFlags.WARN, workspace?.data?.message);
      yield put(errorWorkspaceEditUser(workspace?.data));
    }
  } catch (error) {
    yield put(errorWorkspaceEditUser(error));
  }
}

function* addWorkspaceResourcesSaga({ payload }) {
  yield put(addWorkspaceResourcesLoading(true));
  try {
    const data = yield call(addWorkspaceResourceApi, payload);
    if (data?.status === statusCode.Created201) {
      yield put(addWorkspaceResourcesLoading(false));
      yield put(addWorkspaceResourcesSuccess(data?.data));
      toastNotification(toasterFlags.SUCCESS, data?.data?.message);
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(
        addWorkspaceResourcesError(
          (data?.data && data?.data?.error && data?.data?.message) || {}
        )
      );
    }
  } catch (err) {
    yield put(addWorkspaceResourcesError({}));
    toastNotification(toasterFlags.WARN, errorWentWrong);
  }
  yield put(addWorkspaceResourcesLoading(false));
}

function* getAllSkuCLoudVMSaga({ data }) {
  yield put(getAllCloudVMSkuLoading(true));
  try {
    const workspaceListData = yield call(getAllSkuCloudVMApi, data);
    if (workspaceListData?.status === statusCode.Ok200) {
      yield put(getAllCloudVMSkuSuccess(workspaceListData));
    } else {
      toastNotification(toasterFlags.WARN, workspaceListData?.data?.message);
      yield put(getAllCloudVMSkuError(workspaceListData));
    }
  } catch (err) {
    yield put(getAllCloudVMSkuError(err));
    toastNotification(toasterFlags.WARN, errorWentWrong);
  }
  yield put(getAllCloudVMSkuLoading(false));
}

function* getAllInstanceCloudVMSaga({ payload }) {
  yield put(getAllCloudVMInstanceLoading(true));
  try {
    const workspaceListData = yield call(getAllInstanceCloudVMApi, payload);
    if (workspaceListData?.status === statusCode.Ok200) {
      yield put(getAllCloudVMInstanceSuccess(workspaceListData));
    } else {
      toastNotification(toasterFlags.WARN, workspaceListData?.data?.message);
      yield put(getAllCloudVMInstanceError(workspaceListData));
    }
  } catch (err) {
    yield put(getAllCloudVMInstanceError(err));
    toastNotification(toasterFlags.WARN, errorWentWrong);
  }
  yield put(getAllCloudVMInstanceLoading(false));
}

export function* workspaceManagerRootSaga() {
  yield takeLatest(
    workspaceManager.GET_WORKSPACE_DASHBOARD_LIST,
    getWorkspaceDashboardList
  );
  yield takeLatest(workspaceManager.CREATE_WORKSPACE, createWorkspaceSaga);
  yield takeLatest(workspaceManager.EDIT_WORKSPACE, editWorkspaceSaga);
  yield takeLatest(workspaceManager.ADD_RESOURCE, addResourceSaga);
  yield takeLatest(workspaceManager.EDIT_RESOURCE, editResourceSaga);
  yield takeLatest(workspaceManager.CREATE_AUTH_CONFIG, addAuthConfigSaga);
  yield takeLatest(workspaceManager.EDIT_AUTH_CONFIG, editAuthConfigSaga);
  yield takeLatest(
    workspaceManager.GET_RESOURCE_TEMPLATE,
    getResourceTemplateSaga
  );
  yield takeLatest(
    workspaceManager.REQUEST_WORKSPACE_DETAILS,
    getWorkspaceDetailsSagaFunction
  );
  yield takeLatest(
    workspaceManager.REQUEST_WORKSPACE_DETAILS_USERS,
    getWorkspaceDetailsUsersSagaFunction
  );
  yield takeLatest(
    workspaceManager.DELETE_WORKSPACE_REQUEST,
    deleteWorkspaceFunction
  );
  yield takeLatest(workspaceManager.GET_WORKSPACE_BY_ID, getWorkSpaceByIdSaga);
  yield takeLatest(
    workspaceManager.GET_INSTANCE_SIZE_PRICING,
    getInstanceSizeAndPricingSaga
  );
  yield takeLatest(
    workspaceManager.GET_WORKSPACE_RESOURCE_BY_ID,
    getWorkspaceResourceByIdSaga
  );
  yield takeLatest(
    workspaceManager.GET_WORKSPACE_AUTH_CONFIG_BY_ID,
    getWorkspaceAuthConfigbyIdSaga
  );
  yield takeLatest(
    workspaceManager.WORKSPACE_ACTION_REQUEST,
    workspaceActionHandlerFunction
  );
  yield takeLatest(
    workspaceManager.GET_WORKSPACE_RESOURCE_LIST,
    getWorkspaceResourceListFunction
  );
  yield takeLatest(
    workspaceManager.GET_PUBLIC_WORKSPACE_RESOURCE_LIST,
    getPublicWorkspaceResourceListFunction
  );
  yield takeLatest(
    workspaceManager.LINK_DELINK_RESOURCE,
    linkDeLinkResourceSaga
  );
  yield takeLatest(
    workspaceManager.LIST_USER_INVITATION,
    listUserInivitationSaga
  );
  yield takeLatest(
    workspaceManager.REQUEST_DELETE_WORKSPACE_USER,
    deleteWorkspaceUserInvitationSagaFunction
  );
  yield takeLatest(
    workspaceManager.REQUEST_DOWNLOAD_INVITATION,
    downloadInvitationSaga
  );
  yield takeLatest(
    workspaceManager.GENERATE_INVITE_LINK,
    generateInviteLinkSaga
  );
  yield takeLatest(
    workspaceManager.REQUEST_RESEND_INVITATION,
    resendInvitationSaga
  );
  yield takeLatest(
    workspaceManager.REQUEST_TENANT_LIST_USAGE,
    getWorkspaceTenantsSaga
  );
  yield takeLatest(workspaceManager.REQUEST_WORKSPACES, getWorkspacesSaga);
  yield takeLatest(
    workspaceManager.REQUEST_GENERATE_REPORT_LIST,
    getPreviousUsageReportSaga
  );
  yield takeLatest(
    workspaceManager.REQUEST_GENERATE_REPORT,
    generateReportSaga
  );
  yield takeLatest(workspaceManager.GET_INVITATION, getInvitation);
  yield takeLatest(
    workspaceManager.GET_WORKSPACE_VERIFIED,
    getWorkSpaceVerified
  );
  yield takeLatest(
    workspaceManager.GET_WORKSPACE_EXT_PACKS,
    getExtensionPackSaga
  );
  yield takeLatest(workspaceManager.AAD_USER_LOGIN, loginFunctionForAAD);
  yield takeLatest(workspaceManager.GET_WS_AUTH_RES, getAuthResponseWs);
  yield takeLatest(
    workspaceManager.TENANT_LIST_FOR_WORKSPACE,
    getTenantListFunction
  );
  yield takeLatest(
    workspaceManager?.REQUEST_WORKSPACE_ADD_USER,
    workspaceAddUserFunction
  );
  yield takeLatest(
    workspaceManager?.REQUEST_WORKSPACE_EDIT_USER,
    workspaceEditUserFunction
  );
  yield takeLatest(
    workspaceManager.ADD_WORKSPACE_RESOURCES_ACTION,
    addWorkspaceResourcesSaga
  );
  yield takeLatest(
    workspaceManager.GET_ALL_CLOUD_VM_SKU_ACTION,
    getAllSkuCLoudVMSaga
  );
  yield takeLatest(
    workspaceManager.GET_ALL_CLOUD_VM_INSTANCE_ACTION,
    getAllInstanceCloudVMSaga
  );
}

export default function* rootSaga() {
  yield all([fork(workspaceManagerRootSaga)]);
}
